export const CONTACT_STEPS = {
  TYPE_OF_REQUEST: 0,
  CONTACT_INFORMATION: 1,
  REQUEST_DESCRIPTION: 2,
  MESSAGE_SENT: 3,
};

export const REQUEST_TYPE = {
  BUG_REPORT: 'BUG_REPORT',
  SUPPORT: 'SUPPORT',
};
